import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bc301be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightPanel-background" }, null, -1))
const _hoisted_2 = { class: "rightPanel" }
const _hoisted_3 = { class: "rightPanel-items" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  clickNotClose: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



const store = useStore()
const rightPanel = ref<HTMLElement | null>(null)

const show = computed({
  get: () => store.state.settings.showSettings,
  set: (val: boolean) => {
    store.dispatch('settings/changeSetting', {
      key: 'showSettings',
      value: val
    })
  }
})

watch(() => show.value, (value) => {
  if (value && !props.clickNotClose) {
    addEventClick()
  }
})

onMounted(() => {
  addEventClick()
})

onBeforeUnmount(() => {
  if (rightPanel.value) {
    rightPanel.value.remove()
  }
})

function addEventClick() {
  window.addEventListener('click', closeSidebar)
}

function closeSidebar(evt: MouseEvent) {
  const parent = (evt.target as HTMLElement).closest('.el-drawer__body')
  if (!parent) {
    show.value = false
    window.removeEventListener('click', closeSidebar)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rightPanel",
    ref: rightPanel,
    class: "rightPanel-container"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 512))
}
}

})